import { formatDate, NgIf, AsyncPipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { AsamcoAuthService } from '@asamco/base';
import { User, UserService } from '@asamco/user-management/shared';
import { pathJoin, skipAuthInterceptor } from '@asamco/utils';
import { BehaviorSubject, combineLatest, from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PrettyJsonViewerComponent } from '../../integration-tester/pretty-json-viewer/pretty-json-viewer.component';
import { AuditLogData } from '../../interfaces/audit-log-data.interface';
import { Company } from '../../interfaces/company.interface';
import { LinkTemplate } from '../../interfaces/link-template.interface';
import { LinkType } from '../../interfaces/link-type.interface';
import { SelectedCompanyService } from '../../selected-company/selected-company.service';
import { LinkTemplateService } from '../../services/link-template.service';
import { LinkTypeService } from '../../services/link-type.service';
import { LinkService } from '../../services/link.service';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxoSummaryModule, DxiGroupItemModule, DxiSortByGroupSummaryInfoModule, DxiColumnModule, DxoSelectionModule, DxoSearchPanelModule, DxoPagingModule, DxoGroupPanelModule, DxoGroupingModule } from 'devextreme-angular/ui/nested';
import { DxButtonModule, DxDataGridModule, DxTextBoxModule } from 'devextreme-angular';
import { ApplicationInsightsService } from '../../services/application-insights.service';
import DevExpress from 'devextreme';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';

@Component({
    selector: 'app-shell-admin-financial-issues-overview',
    templateUrl: './admin-financial-issues-overview.component.html',
    styleUrls: ['./admin-financial-issues-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        DxDataGridModule,
        DxoSummaryModule,
        DxiGroupItemModule,
        DxiSortByGroupSummaryInfoModule,
        DxiColumnModule,
        DxTemplateModule,
        NgIf,
		DxTextBoxModule,
        DxoSelectionModule,
        DxoSearchPanelModule,
        DxoPagingModule,
        DxoGroupPanelModule,
        DxoGroupingModule,
		DxButtonModule,
        PrettyJsonViewerComponent,
        AsyncPipe,
    ],
})
export class AdminFinancialIssuesOverviewComponent implements OnInit {
	@ViewChild('picklistcomponent', { static: false }) prettyJsonComponentpicklist: PrettyJsonViewerComponent;
	public jobloginsight$: Observable<any[]> = new Observable<any[]>();

	public adminInstanceLog: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

	traceparentInfo$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

	stateSortOrder: string;

	traceparentid: string;

	constructor(
		@Inject(LOCALE_ID) private locale: string,
		private linkService: LinkService,
		private userService: UserService,
		private companyService: SelectedCompanyService,
		private auth: AsamcoAuthService,
		private linkTemplateService: LinkTemplateService,
		private linkTypeService: LinkTypeService,
		private http: HttpClient,
		private applicationInsightsService: ApplicationInsightsService
	) {}

	ngOnInit(): void {
		this.stateSortOrder = 'desc';
		this.jobloginsight$ = this.getJobLogAdminInsightData();
	}

	logObject(e: any) {
		console.log(e);
	}

	sendTraceparentid(e: any)
	{
		this.applicationInsightsService.getTraceparentInfo(this.traceparentid).subscribe(e => {
			this.traceparentInfo$.next(e);
		})
	}

	onCellClick(e: DxDataGridTypes.CellClickEvent)
	{
		console.log(e.value)
		navigator.clipboard.writeText(e.value).then(() => {
			console.log('Copied to clipboard');
		  }).catch(err => {
			console.error('Failed to copy: ', err);
		  });
	}

	padGroupingText(obj: any) {
		let dataObj = null;
		let issueCount: number = 0;
		let issueString = 'issue';
		if (obj.data?.collapsedItems) {
			dataObj = obj.data.collapsedItems[0];
			issueCount = obj.data.collapsedItems.length;
		} else if (obj.data?.items) {
			dataObj = obj.data.items[0];
			issueCount = obj.data.items.length;
		}

		let date: string = '[' + formatDate(dataObj.creationDate, 'dd/MM/yyyy HH:mm', this.locale) + ']';
		let companyIdentifier: string = '[' + dataObj.fullCompanyIdentifier + ']';
		let fromLinkTemplateDescription: string = dataObj.fromLinkTemplateDescription;
		let toLinkTemplateDescription: string = dataObj.toLinkTemplateDescription;
		let linkName: string = '[' + dataObj.linkName + ']';

		if (issueCount > 1) {
			issueString = 'issues';
		}
		let fullString: string =
			date +
			' ' +
			companyIdentifier +
			' - ' +
			linkName +
			' - ' +
			fromLinkTemplateDescription +
			' - ' +
			toLinkTemplateDescription +
			' - ' +
			'[' +
			issueCount +
			' ' +
			issueString +
			']';
		return fullString;
		//| date:'d/MM/yyyy H:mm' }}] - [{{obj.data.collapsedItems[0].fullCompanyIdentifier}}] {{obj.data.collapsedItems[0].fromLinkTemplateDescription}} - {{obj.data.collapsedItems[0].toLinkTemplateDescription}}
		return 'ok';
	}

	openAzureHistoryIfExists(data: any) {
		console.log(data.row.data);
		this.linkService.GetFunctionAppInstanceHistory(data.row.data.linkId, data.row.data.instanceId).subscribe(e => {
			this.adminInstanceLog.next(e);
			this.prettyJsonComponentpicklist.toggleModal(true);
		});
	}

	calculateCellValue(rowData: any) {
		return rowData.id;
	}

	getJobLogAdminInsightData(): Observable<AuditLogData[]> {
		let ownParams = new HttpParams();

		ownParams = ownParams.set('$filter', `(JobLogType eq 4)`);

		ownParams = ownParams.set(
			'$select',
			`id,creationDate,Col_1_Val,Col_2_Val,Col_3_Val,Col_4_val,JobLogType,instanceId,fullCompanyIdentifier,linkName,fromLinkTemplateDescription,toLinkTemplateDescription,sessionIdentifier,linkId`
		);

		return from(this.auth.getPrimaryTokenAsync()).pipe(switchMap(
			pt => this.http.get(pathJoin([this.auth.userSession.backend.odataBaseUrl, 'dynamic/_AL3_vw_JobLogAdminInsight']), {
				headers: skipAuthInterceptor(new HttpHeaders().set('Authorization', 'Bearer ' + pt)),
				params: ownParams,
			})
		),
		// Map to odata value to filter out context
		map((data: any) => {
			//let result = data.value.sort((a,b) => a.creationDate - b.creationDate); // b - a for reverse sort
			return data.value;
		}));
	}
}
